



















































import Vue from "vue";
import { UserService, Tools } from "../../services";
import { UpdatePasswordI, CredentialValidationResponse } from "vue/types/vue";
export default Vue.extend({
  name: "UpdatePasswordForm",
  props: {
    updateMessage: {
      type: String,
      default: ""
    },
    disabled: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      pw: {} as UpdatePasswordI,
      unable: false,
      success: false,
      showMessage: false,
      modalMessage: "",
      modalHeader: "",
      focused: ""
    };
  },
  mounted() {
    this.pw = {
      old: "",
      newpw: "",
      verify: ""
    }
  },
  computed: {
    valid: function(): boolean {
      const pw = this.pw;
      return pw.newpw !== "" && pw.old !== pw.newpw && pw.newpw === pw.verify;
    }
  },
  methods: {
    update: async function(): Promise<void> {
      const pwvalidation: CredentialValidationResponse = Tools.passwordValidation(
        this.pw.newpw
      );

      if (pwvalidation.invalid) {
        this.modalHeader = pwvalidation.header;
        this.modalMessage = pwvalidation.message;
        this.showMessage = true;
      } else if (this.pw.newpw !== this.pw.verify) {
        this.modalHeader = "Ogiltigt lösenord";
        this.modalMessage = "Lösenorden matchar inte. Försök igen.";
        this.showMessage = true;
      } else {
        this.$emit("update", this.pw);
      }
    },
    closeMessage: function(): void {
      this.showMessage = false;
      this.modalMessage = "";
      this.modalHeader = "";
      this.$emit("confirm");
    },
    confirmUpdate: function(): void {
      this.$emit("confirm");
    },
    focus: function(focus: string): void {
      this.focused = focus;
    }
  }
});
